<template>
    <div>

        <config-main-title>
            Fila de Autorização
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Fila
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma fila identificada.'" 
                icon="fas fa-search"
                :action="'Incluir Fila'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-secondary" @click="acessos(dado)" v-else>
                            <i class="fas fa-user-lock mr-2"></i>
                            {{ dado.acessos.length }}
                        </button>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_fila_autorizacao ? '' : 'Nova' }}
                            Fila
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_fila_autorizacao">
                                #{{ item.id_fila_autorizacao }}
                            </span>                            
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Informe o título da fila..."
                                    label="Tïtulo"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="3"
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    type="checkbox-group"
                                    label="Visualizar apenas autorização geradas pelo próprio usuário"
                                    :validate="validate"
                                    v-model="item.fl_apenas_criados" />
                            </div>
                        </div>

                        
                        <!-- Filtros -->
                        <filtro-model class="mt-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="filaLaudo" :id="item.id_fila_laudo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_fila_autorizacao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import EdicaoAcessos from '../shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        FiltroModel,
        EdicaoAcessos,
    },

    computed: { 
        lista_filtros: function () { 

            if ( !this.item ) 
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\recepcao', search:'Recepção', service: 'recepcaos.index', parms: { filtros: true }},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }

            opcoes.push({id:'tag-usuario', search:'Classificação do Usuário Criador', service: 'usuarios.index', parms: { ativos: true }, tag: true});
            
            return _.orderBy(opcoes, 'search');
        },

    },

    methods: { 
        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\filaAutorizacao', item.id_fila_autorizacao);
        },

        serviceFiltro(model) {
            switch (model) {
                case 'App\\azure\\medico': return 'medicos.index';
                case 'App\\azure\\unidadeOperacao': return 'unidade_operacaos.index';
                case 'App\\azure\\operadora': return 'operadoras.index';
                case 'App\\azure\\procedimento': return 'procedimentos.index';
            }
            return null;
        },

        incluir_filtro(item) { 
            item.filtros.push({ 
                id_fila_autorizacao_filtro: null, 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
            });
        },
        incluir () { 
            this.validate = false;

            let item = {
                st_titulo: "", 
                fl_ativo: true,
                st_observacoes: "", 
                fl_apenas_criados: false, 
                filtros: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'fila_autorizacoes',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            if ( !this.item.endereco ) { 
                this.item.endereco = { cidade: {} };
            }

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'fila_autorizacoes',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'fila_autorizacoes',
                dados: item,
            });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    beforeMount() { 
        if ( this.$route.name == 'c-fila-autoriz' ) { 
            this.fila_proced = true;
        }
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Fila de Autorização", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>